import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { goToConversations, pathnames } from 'utils/routerHelpers';

import React, { useState } from 'react';

import { Badge, Button } from '@thinkific/chalk';
import { Chats, Plus } from '@thinkific/chalk/react-icons';
import { ExpandableMenuSection } from '@thinkific/chalk/recipes/ExpandableMenuSection';
import { MenuItemWithSymbols } from '@thinkific/chalk/recipes/MenuItemWithSymbols';

import ConversationsList from 'components/new/chat/Conversations/ConversationsList';
import { useChatContext } from 'components/new/chat/providers/ChatProvider/ChatProvider';
import MenuIcon from 'components/new/ui/MenuIcon/MenuIcon';

import * as css from './DirectMessaging.css';

interface DirectMessagingProps {
  communityId: string;
}

export const DirectMessaging = ({ communityId }: DirectMessagingProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const [sectionsExpanded, setSectionsExpanded] = useState(true);
  const { toggleNewConversationModal, conversations } = useChatContext();
  const hasChannels = conversations && conversations.length > 0;

  return (
    <section data-qa="messaging-menu-item">
      {!hasChannels && (
        <MenuItemWithSymbols
          active={router.pathname === pathnames.directMessaging.index}
          className={css.menuItem}
          data-qa="members-menu-item"
          endSymbol={<Badge label={t('pages-direct_messages_new', 'New')} variant="neutral" />}
          label={t('pages-direct_messages_title', 'Direct messages')}
          leadSymbol={<MenuIcon className={css.staticNavItem} iconName={Chats} />}
          onClick={() => goToConversations(router, communityId)}
        />
      )}
      {hasChannels && (
        <div className={css.directMessagingContainer}>
          <ExpandableMenuSection
            open={sectionsExpanded}
            title={t('communities_sidebar-spaces', 'Direct messages')}
            titleItem={
              <Button
                dataQa="create-conversation-plus-button"
                emphasis="low"
                icon={Plus}
                size="xs"
                hiddenLabel
                onClick={toggleNewConversationModal}
              >
                {t('sidebar-conversation-create', 'Create conversation')}
              </Button>
            }
            onToggle={() => setSectionsExpanded(!sectionsExpanded)}
          >
            <ConversationsList captionLength={34} />
          </ExpandableMenuSection>
        </div>
      )}
    </section>
  );
};
